declare namespace $ {

	export class $mol_icon_alert extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=alert.view.tree.d.ts.map